<template>
  <article
    class="pages-reels-grid-list-block button-circle-1-trigger"
    ref="block"
    :class="{
      'is-hover': isHover,
      'is-alternative': alternative,
    }"
  >
    <div
      class="pages-reels-grid-list-block__wrap"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
    <template v-if="props.item.linkReference && props.item.linkReference.internalLink">
      <nuxt-link
      :to="
        localePath({ name: linkRouteCalc(props.item.linkReference.internalLink), params: { slug: props.item.linkReference.internalLink.slug } })
      "
      class=""
      :class="{
        'is-hover': isHover,
      }"
    >
     <!-- Content -->
      <div class="pages-reels-grid-list-block__content is-rounded-wrap m-bottom-24px">
        <div
          class="pages-reels-grid-list-block__content__preview"
          data-animate="block-image-preview"
        >
          <WidgetPicture
            class="is-cover"
            :image="{ custom: props.item?.image?.responsiveImage }"
            :lazyLoad="true"
            :alt="props.item.title"
          />
        </div>
        <div
          v-if="hasPreview"
          class="pages-reels-grid-list-block__content__video"
          data-animate="block-video-preview"
        >
          <WidgetVideo
            class="is-cover"
            :videoUrl="props.item?.linkVideoPreview"
            :loop="true"
            :forcePlay="!touch && isHover"
            :autoplay="touch"
            :muted="true"
            :preload="'none'"
            :playInViewport="touch"
            @play="onViewportEnter"
            @pause="onViewportLeave"
          />
        </div>


        <!-- Quick View button -->
        <div
          class="pages-reels-grid-list-block__content__quickview"
          v-if="hasQuickView || alternative"
        >
        <WidgetButtonCtaIco
        data-animate="block-quick-view"
         v-if="hasQuickView"
          :label="$t('cta.playVideo')"
           @click="(event) => onQuickView(event)"
        />
         <!-- <button
            v-if="hasQuickView"
            class="button-round-1 is-transparent"
            data-animate="block-quick-view"
            @click="(event) => onQuickView(event)"
          >
            <span>{{ $t('cta.playVideo') }}</span>

            <img
              src="@/assets/img/ico/ico-eye-white.svg"
              width="19"
              height="12"
              alt="White eye"
            />
          </button>-->

         
        </div>
      </div>
      <!-- Hesder -->
      <header class="pages-reels-grid-list-block__header">
        <div class="pages-reels-grid-list-block__header__title">
          <!-- Title -->
          <h3 class="title-s-2 is-text-uppercase">
            <strong>{{ props.item.title }}</strong>
          </h3>

          <!-- Subtitle -->
          <div class="text-xl-3" v-if="props.item.caption" v-html="props.item.caption" />
           
          
        </div>

        <div
          v-if="!alternative"
          class="button-circle-1 is-blue is-small is-diagonal"
        >
          <img
            src="@/assets/img/ico/ico-next-arrow-blue.svg"
            width="20"
            height="20"
            alt="Blue arrow"
          />
        </div>
      </header>
      </nuxt-link>
    </template>
    <template v-else>
      
      <!-- Content -->
      <div class="pages-reels-grid-list-block__content is-rounded-wrap m-bottom-24px">
        <div
          class="pages-reels-grid-list-block__content__preview"
          data-animate="block-image-preview"
        >
          <WidgetPicture
            class="is-cover"
            :image="{ custom: props.item?.image?.responsiveImage }"
            :lazyLoad="true"
            :alt="props.item.title"
          />
        </div>
        <div
          v-if="hasPreview"
          class="pages-reels-grid-list-block__content__video"
          data-animate="block-video-preview"
        >
          <WidgetVideo
            class="is-cover"
            :videoUrl="props.item?.linkVideoPreview"
            :loop="true"
            :forcePlay="!touch && isHover"
            :autoplay="touch"
            :muted="true"
            :preload="'none'"
            :playInViewport="touch"
            @play="onViewportEnter"
            @pause="onViewportLeave"
          />
        </div>


        <!-- Quick View button -->
        <div
          class="pages-reels-grid-list-block__content__quickview"
          v-if="hasQuickView || alternative"
        >
        <WidgetButtonCtaIco
        data-animate="block-quick-view"
         v-if="hasQuickView"
          :label="$t('cta.playVideo')"
           @click="(event) => onQuickView(event)"
        />
         <!-- <button
            v-if="hasQuickView"
            class="button-round-1 is-transparent"
            data-animate="block-quick-view"
            @click="(event) => onQuickView(event)"
          >
            <span>{{ $t('cta.playVideo') }}</span>

            <img
              src="@/assets/img/ico/ico-eye-white.svg"
              width="19"
              height="12"
              alt="White eye"
            />
          </button>-->

         
        </div>
      </div>
      <!-- Hesder -->
      <header class="pages-reels-grid-list-block__header">
        <div class="pages-reels-grid-list-block__header__title">
          <!-- Title -->
          <h3 class="title-s-2 is-text-uppercase">
            <strong>{{ props.item.title }}</strong>
          </h3>

          <!-- Subtitle -->
          <div class="text-xl-3" v-if="props.item.caption" v-html="props.item.caption" />
           
          
        </div>

        <div
          v-if="!alternative"
          class="button-circle-1 is-blue is-small is-diagonal"
        >
          <img
            src="@/assets/img/ico/ico-next-arrow-blue.svg"
            width="20"
            height="20"
            alt="Blue arrow"
          />
        </div>
      </header>
    </template>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ListingProjectBlock',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  item: Object,
  alternative: Boolean,
})

const block = ref(null)

const isHover = ref(false)
const touch = ref(false)

const duration = 0.6
const durationFast = 0.4
const ease = 'power2.inOut'

const hasPreview = computed(() => props.item?.linkVideoPreview)
const hasQuickView = computed(() => props.item?.linkVideo)

const quickview = useState('quickview', () => null)

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const onMouseEnter = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')

  isHover.value = true

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }

  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '0%', duration: durationFast, ease, stagger: 0.1 })
  }
  
}

const onMouseLeave = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')


  isHover.value = false

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }

  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '100%', duration: durationFast, ease, stagger: 0.1 })
  }
  
}

const onViewportEnter = () => {
  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')


  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }
  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '0%', duration: durationFast, ease, stagger: 0.1 })
  }
}

const onViewportLeave = () => {
  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')


  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }
  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '100%', duration: durationFast, ease, stagger: 0.1 })
  }
}

const onQuickView = (event) => {
  event.stopPropagation() // Previene la propagazione del click al link
  event.preventDefault() // Previene l'azione predefinita del bottone

  quickview.value = props.item?.linkVideo
}

const linkRouteCalc = (el) => {
  if (el.__typename === 'ExpertiseRecord') return 'expertise-slug'
  if (el.__typename === 'ContentRecord') return 'contents-slug'
  if (el.__typename === 'IndustryRecord') return 'industries-slug'
  if (el.__typename === 'SolutionRecord') return 'solutions-slug'
  if (el.__typename === 'ReelRecord') return 'reels-slug'
  if (el.__typename === 'ProjectRecord') return 'projects-slug'
}

</script>

<style lang="scss">
@import './style.scss';
</style>
